const INITIAL_STATE = { list: [], loading: false }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CONTROLADOR_ERRO_FETCHED':
            // Agrupa por grupo_fisico_id + numero_controlador mantendo somente a notificação mais recente
            {
                const listaServidor = Array.isArray(action.payload.data) ? action.payload.data : [];
                const map = new Map();
                for (const item of listaServidor) {
                    const key = `${item.grupo_fisico_id}-${item.numero_controlador}`;
                    const current = map.get(key);
                    const itemDate = new Date(`${item.data_erro} ${item.hora_erro}`);
                    if (!current) {
                        map.set(key, item);
                    } else {
                        const currentDate = new Date(`${current.data_erro} ${current.hora_erro}`);
                        if (itemDate > currentDate) map.set(key, item);
                    }
                }
                const agrupada = Array.from(map.values()).sort((a, b) => {
                    if (a.grupo_fisico_id !== b.grupo_fisico_id) return a.grupo_fisico_id - b.grupo_fisico_id;
                    if (a.numero_controlador !== b.numero_controlador) return a.numero_controlador - b.numero_controlador;
                    return new Date(`${b.data_erro} ${b.hora_erro}`) - new Date(`${a.data_erro} ${a.hora_erro}`);
                });
                return { ...state, list: agrupada };
            }
        case 'CONTROLADOR_ERRO_LIST_LOADING':
            return { ...state, loading: action.payload };
        case 'CONTROLADOR_ERRO_DETALHES_FETCHED':
            // Para detalhes de um controlador específico, mostrar todos os erros sem agrupar
            {
                const listaServidor = Array.isArray(action.payload.data) ? action.payload.data : [];
                // Ordenar por data/hora mais recente primeiro
                const ordenada = listaServidor.sort((a, b) => {
                    const dateA = new Date(`${a.data_erro} ${a.hora_erro}`);
                    const dateB = new Date(`${b.data_erro} ${b.hora_erro}`);
                    return dateB - dateA;
                });
                return { ...state, list: ordenada, loading: false };
            }
        case 'CONTROLADOR_ERRO_LIST_UPDATED':
            // Agrupa por grupo_fisico_id + numero_controlador mantendo somente a notificação mais recente
            {
                const lista = Array.isArray(action.payload) ? action.payload : [];
                const map = new Map();
                for (const item of lista) {
                    const key = `${item.grupo_fisico_id}-${item.numero_controlador}`;
                    const current = map.get(key);
                    const itemDate = new Date(`${item.data_erro} ${item.hora_erro}`);
                    if (!current) {
                        map.set(key, item);
                    } else {
                        const currentDate = new Date(`${current.data_erro} ${current.hora_erro}`);
                        if (itemDate > currentDate) map.set(key, item);
                    }
                }
                const agrupada = Array.from(map.values()).sort((a, b) => {
                    if (a.grupo_fisico_id !== b.grupo_fisico_id) return a.grupo_fisico_id - b.grupo_fisico_id;
                    if (a.numero_controlador !== b.numero_controlador) return a.numero_controlador - b.numero_controlador;
                    return new Date(`${b.data_erro} ${b.hora_erro}`) - new Date(`${a.data_erro} ${a.hora_erro}`);
                });
                return { ...state, list: agrupada };
            }

        case 'CONTROLADOR_ERRO_ADDED':
            // Faz upsert por grupo_fisico_id + numero_controlador e reordena
            {
                const keyNew = `${action.payload.grupo_fisico_id}-${action.payload.numero_controlador}`;
                const filtrada = state.list.filter(item => `${item.grupo_fisico_id}-${item.numero_controlador}` !== keyNew);
                const nova = [action.payload, ...filtrada];
                const ordenada = nova.sort((a, b) => {
                    if (a.grupo_fisico_id !== b.grupo_fisico_id) return a.grupo_fisico_id - b.grupo_fisico_id;
                    if (a.numero_controlador !== b.numero_controlador) return a.numero_controlador - b.numero_controlador;
                    return new Date(`${b.data_erro} ${b.hora_erro}`) - new Date(`${a.data_erro} ${a.hora_erro}`);
                });
                return { ...state, list: ordenada };
            }
        case 'CONTROLADOR_ERRO_SYNC_LOCAL_STORAGE':
            // Atualiza o estado com as notificações armazenadas no localStorage
            return { ...state, list: action.payload }
        case 'ERRO_PAGE':
            return { ...state, paginaAtual: action.payload };
        default:
            return state
    }
}